import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
